/**
 * Export component file to be used on project
 */

import Dashboard from './Dashboard';
export default Dashboard;